import device from '@/utils/device'

const JsBridgePlugin = {}

JsBridgePlugin.install = function (Vue) {
  if (device.webView && !device.miniProgram) {
    if (device.android) {
      androidSetWebViewJavaScriptBridge(function (bridge) {
        Vue.prototype.$jsBridge = bridge
      })
    } else if (device.ios) {
      iosSetupWebViewJavaScriptBridge(function (bridge) {
        Vue.prototype.$jsBridge = bridge
      })
    }
  }
}
export default JsBridgePlugin

export function androidSetWebViewJavaScriptBridge (callback) {
  window.WebViewJavascriptBridge && callback(window.WebViewJavascriptBridge)
  !window.WebViewJavascriptBridge && document.addEventListener('WebViewJavascriptBridgeReady', () => {
    callback(window.WebViewJavascriptBridge)
  }, false)
}

export function iosSetupWebViewJavaScriptBridge (callback) {
  if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge); }
  if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
}

let func = () => { }

if (device.webView) {
  if (device.android) {
    func = androidSetWebViewJavaScriptBridge
  } else if (device.ios) {
    func = iosSetupWebViewJavaScriptBridge
  }
}

export const setJsBridge = func
